<template>
  <div>
    <table class="col-12" v-if="wasteCars && wasteCars.length">
      <thead>
      <tr>
        <th class="width-70">Номер автомобиля</th>
        <th class="width-10">Объём загрузки</th>
        <th class="width-10">Коэффициент уплотнения</th>
        <th>Статус</th>
        <th class="width-15">Действия</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="car in wasteCars" :key="car.id">
        <td>{{ car.CarNumber }}</td>
        <td>{{ car.CarVolume }} {{ car.Measurement }}</td>
        <td>{{ car.Compaction }}</td>
        <td><span class="icon-Check green"></span>Активный</td>
        <td>
          <button
              class="btn-edit"
              @click="editCar(car)"
              title="Редактировать автомобиль"
          >
            <span class="icon-Edit"></span>Изменить
          </button>
        </td>
      </tr>
      </tbody>
    </table>

<!--    &lt;!&ndash; Состояние "нет автомобилей" &ndash;&gt;-->
<!--    <div class="col-12" v-else-if="wasteCars && !wasteCars.length">-->
<!--      Нет автомобилей-->
<!--    </div>-->

    <div class="col-12" v-else>
      Автомобилей не найдено
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    wasteCars() {
      return this.$store.state.waste_cars["Cars"]
    },
  },
  created() {
    this.$store.dispatch("fetchWasteCars", this.currentUser.company_inn);
  },
  methods: {
    editCar(car) {
      this.$store.commit('setCurrentCar', car);
      this.$router.push({
        path: `/edit-car/${car.id}`,
        query: {
          number: car.CarNumber,
          volume: car.CarVolume,
          compaction: car.Compaction
        }
      });
    }
  }
};
</script>


<style scoped>
.btn-edit {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border-radius: 8px;
  border: 1px solid transparent;
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
  background: #4f46e5;
  color: #fff;
  box-shadow: 0 2px 8px rgba(79, 70, 229, 0.25);
  cursor: pointer;
  transition: transform .2s ease, box-shadow .2s ease, background-color .2s ease, border-color .2s ease;
}

.btn-edit:hover {
  background: #4338ca;
  box-shadow: 0 6px 14px rgba(79, 70, 229, 0.32);
  transform: translateY(-1px);
}

.btn-edit:active {
  background: #3730a3;
  box-shadow: 0 2px 6px rgba(79, 70, 229, 0.2);
  transform: translateY(0);
}

.btn-edit:focus {
  outline: none;
  border-color: #a5b4fc;
  box-shadow: 0 0 0 3px rgba(165, 180, 252, 0.6);
}

.icon-Edit {
  display: inline-block;
  width: 16px;
  height: 16px;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='white'%3E%3Cpath d='M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: center;
  transition: transform .2s ease;
}

.btn-edit:hover .icon-Edit { transform: scale(1.05); }

.width-15 { width: 15%; min-width: 120px; }

@media (max-width: 768px) {
  .btn-edit { padding: 6px 12px; font-size: 13px; }
  .width-15 { width: 20%; min-width: 100px; }
  .icon-Edit { width: 14px; height: 14px; }
}

@media (max-width: 480px) {
  .btn-edit {
    padding: 0;
    width: 36px; height: 36px;
    border-radius: 10px;
    justify-content: center;
  }
  .btn-edit span:last-child { display: none; }
}
</style>